import type { DisplayStyles } from 'models';

export const setElementDisplayById = (
  elementId: string,
  displayType: DisplayStyles,
) => {
  const stepCounter = document.getElementById(elementId);

  if (stepCounter) {
    stepCounter.style.display = displayType;
  }
};

export const loadScriptInHead = (source: string) => {
  const node = document.createElement('script');
  node.type = 'text/javascript';
  node.src = source;
  node.async = false;
  document.getElementsByTagName('head')[0].appendChild(node);
  return node;
};
